import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';

import './BackgroundStyleSelector.css';


class BackgroundStyleSelector extends Component {
  static propTypes = {
    patchCustomTheme: PropTypes.func.isRequired,
    setCustomMode: PropTypes.func.isRequired,
    me: PropTypes.object,
  };

  static defaultProps = {
    me: null,
  };

  state = {
    currentStyle: null,
  };

  componentDidMount() {
    const { me } = this.props;
    if (me && me.custom_theme) {
      this.setState({ currentStyle: me.custom_theme.background_style });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.me.custom_theme.background_style !== prevProps.me.custom_theme.background_style
    ) {
      this.setState({ currentStyle: this.props.me.custom_theme.background_style });
    }
  }

  render() {
    const styleItems = ['Flat', 'Up', 'Down'];
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;

    return (
      <div className="background-style-selector__component">
        {styleItems.map((item, index)=> (
          <div className="item-wrapper" key={index.toString()}>
            <div
              
              className={`style-item
                ${this.state.currentStyle === item.toLowerCase() ?
                ' active' : null}`}
              onClick={() => {
                if (me.theme) { this.props.setCustomMode(); }
                const form = new FormData();
                form.append('background_style', item.toLowerCase());
                form.append('background_animated_style', '');
                this.props.patchCustomTheme(customThemeId, form);
                this.setState({ currentStyle: item.toLowerCase() });
              }}
              role="button"
              tabIndex={-1}
            >
              <div className={`wrapper ${item.toLowerCase()}`}></div>
              
            </div>
            <div className="text">{item}</div>
          </div>
          ))
        }
      </div>
    );
  }
}


const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  },
)(BackgroundStyleSelector);
